import React, {useEffect} from 'react';
import { withRouter } from 'react-router-dom';
import { facebookOptInCallback } from '../../api/socialAccountsApi';
import { useDispatch } from 'react-redux';
import { setLoading } from '../../commons/components/application/miscActions';

const FacebookOptInCallback = ({history}) => {

    const dispatch = useDispatch()

    useEffect(() => {
        callback(window.location.search)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    
    const callback = async (params) => {
        dispatch(setLoading(true))
        const response = await facebookOptInCallback(params)
        const companyId = response && response.data && response.data.data && response.data.data.companyId
        dispatch(setLoading(false))
        history.push(`/socialaccounts?companyId=${companyId}`)
    }

    return (<></>)
}

export default withRouter(FacebookOptInCallback)
